export default {"src":"/_next/static/media/twitter-icon-white.ded49ea3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};